// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Ouroboros_Models_Brands_ErrorInfoText from "../Ouroboros.Models.Brands.ErrorInfoText/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_ProbingQuestions from "../Ouroboros.Models.Brands.ProbingQuestions/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Untagged_Union from "../Untagged.Union/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var asOneOf = /* #__PURE__ */ Untagged_Union.asOneOf();
var DocumentCreationAction = function (x) {
    return x;
};
var tsBridgeDocumentCreationA = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("DocumentCreationAction")("__brandDocumentCreationAction"));
        });
    }
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runDocumentCreationAction = function (v) {
    return v;
};
var navigateToPromptThroughDocSelect = function (env) {
    return function (question) {
        return Ouroboros_Services_Clients_Interop_IO.chain(function (v) {
            return runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.documentDetailsPromptRoute)(Ouroboros_Models_Brands_ProbingQuestions.makeProbingQuestions(question)));
        })(runNavigate(env.navigate)(env.documentSelectionRoute));
    };
};
var mkDocumentCreationAction = DocumentCreationAction;
var lifecycleStatusCodeOption = function (errorValue) {
    return errorValue.statusCode;
};
var toLoadingErrorInput = function (errorValue) {
    var message = Ouroboros_Models_Core_ErrorHandlers.lifecycleErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: lifecycleStatusCodeOption(errorValue)
    });
    return {
        message: message.message,
        info: message.info
    };
};
var handleLifecycleError = function (loading) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var handleFetchDocumentsSuccess = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.availableDocuments))(response.documents)));
    };
};
var handleFetchDocumentsError = function (loading) {
    return function (errorValue) {
        var message = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to fetch documents");
        var info = Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Models_Brands_ErrorInfoText.makeErrorInfoText(Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message)));
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(loading.setError({
            message: message,
            info: info
        })));
    };
};
var refreshDocuments = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleFetchDocumentsError(env.loading))(handleFetchDocumentsSuccess(env))(env.lifecycle.listAvailableDocuments);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
};
var handleCreateDocumentNavigation = function (env) {
    return function (question) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(navigateToPromptThroughDocSelect(env)(question)));
    };
};
var fetchDocumentAndRefreshTask = function (env) {
    return function (documentId) {
        return Ouroboros_Services_Clients_Interop_TaskEither.chain(function (document) {
            return Ouroboros_Services_Clients_Interop_TaskEither.rightTask(Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return refreshDocuments(env);
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(env.document))(document))));
        })(env.lifecycle.fetchDocument(documentId));
    };
};
var handleCreateDocumentSuccess = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env.loading))(function (v) {
            return handleCreateDocumentNavigation(env)(response.prompting_question);
        })(fetchDocumentAndRefreshTask(env)(response.document_id));
    };
};
var documentationPath = "/documentation/../frontend/documentation/controllers/document_creation_controller.md";
var createDocumentTask = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env.loading))(handleCreateDocumentSuccess(env))(env.lifecycle.createDocument(asOneOf(request)));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var mkDocumentCreationController = function (env) {
    return {
        onInit: mkDocumentCreationAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(refreshDocuments(env))),
        onCreateDocument: function (request) {
            return mkDocumentCreationAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(createDocumentTask(env)(request)));
        }
    };
};
export {
    DocumentCreationAction,
    mkDocumentCreationController,
    runDocumentCreationAction,
    documentationPath,
    tsBridgeDocumentCreationA
};
//# sourceMappingURL=index.js.map
